import { CreationContext, EventGroup, MarketCard } from "../../types";
import { enabledCasinoSizes } from "@fresh8/types/src/featureFlags";
import { isError, isSuccess } from "../../../../lib/provideInjectors";

export function createCasinoCard(
  _: EventGroup[],
  context: CreationContext
): Array<MarketCard> {
  if (!enabledCasinoSizes.includes(context.size.name)) return [];

  if (isError(context.casinoData!)) return [];

  if (
    isSuccess(context.casinoData!) &&
    context.casinoData.data.raw.amount_of_games === 0
  )
    return [];

  return [
    new MarketCard({
      type: "casinoHighlight",
      eventId: "",
      marketIds: [],
      optionIds: null
    }),
    new MarketCard({
      type: "casinoList",
      eventId: "",
      marketIds: [],
      optionIds: null
    })
  ];
}
